import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWrite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWrite"><Path d="M21 3H3V4.5H21V3Z" fill="currentColor"/><Path d="M17.2365 6.68945L22.3107 11.7636L12.0742 22.0001H7V16.9259L17.2365 6.68945Z" fill="currentColor"/><Path d="M11 7V8.5H3V7H11Z" fill="currentColor"/><Path d="M8.0022 11H3V12.5H8.0022V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWrite;
